var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var ArticleBody = function () {
};

ArticleBody.prototype.init = function () {
};

module.exports = new ArticleBody;
